import { render, staticRenderFns } from "./AnswerListing.vue?vue&type=template&id=0f4d7dea&scoped=true"
import script from "./AnswerListing.vue?vue&type=script&lang=js"
export * from "./AnswerListing.vue?vue&type=script&lang=js"
import style0 from "./AnswerListing.vue?vue&type=style&index=0&id=0f4d7dea&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4d7dea",
  null
  
)

export default component.exports